import { MarkerClustering } from './markerClustering'

window.VWFS = window.VWFS || {};
VWFS.HereMap = function (component) {

    var dataPool;
    var initLatitude;
    var initLongitude;
    var initZoom;
    var pinIconSvg;

    var map;
    var markerClustering = null;
    var markerClusteringImage = "/etc.clientlibs/bluelabel/clientlibs/clientlib-heremap/resources/m";
    var infoWindow;

    var showButtonApplySelection = false;
    var textApplySelection;
    var listener = null;

    var dataInitLatitude;
    var dataInitLongitude;

    /**
     * INIT
     */
    this.init = function () {
        // GET DATA-ATTRIBUTES FROM HTML
        dataInitLatitude = component.getAttribute('data-initLatitude');
        dataInitLongitude = component.getAttribute('data-initLongitude');
        var dataInitZoom = component.getAttribute('data-initZoom');
        var dataPinIcon = component.getAttribute('data-pin-icon');
        var dataTextApplySelection = component.getAttribute('data-text-apply-selection');
        markerClusteringImage = component.getAttribute('data-marker-cluster-image-path') || markerClusteringImage;

        initLatitude = (dataInitLatitude && 0 !== dataInitLatitude.length) ? Number(dataInitLatitude) : Number(0);
        initLongitude = (dataInitLongitude && 0 !== dataInitLongitude.length) ? Number(dataInitLongitude) : Number(0);
        initZoom = (dataInitZoom !== null && dataInitZoom !== undefined && 0 !== dataInitZoom.length) ? Number(dataInitZoom) : Number(2);

        pinIconSvg = (dataPinIcon !== null && dataPinIcon !== undefined) ? dataPinIcon : {};

        showButtonApplySelection = component.hasAttribute('data-button-apply-selection');
        textApplySelection = dataTextApplySelection ? dataTextApplySelection : "apply selection";

        dataPool = component.getAttribute('data-poi-datapool');
        var key = component.getAttribute("data-key");
        if (!key) {
            console.debug("HereMap.js : An error Occurred, No Key provided!");
            return;
        }

        // LOAD HERE-MAP LIBRARY
        VWFS.MapHelper.loadLibrary(function () {
            initMap(key);
        });


        // ADD EVENT LISTENER
        component.addEventListener("updatePointsOfInterests", updatePointsOfInterests);
        component.addEventListener("registerListener", onRegisterListener);

    }

    /**
     * INIT MAP
     * Initiates the here map
     */
    var initMap = function (key) {
        const languageCode = VWFSUtils.getMetaContent("datalayer-language");
        const countryCode = VWFSUtils.getMetaContent("datalayer-countryCode");

        let platform = new H.service.Platform({
            'apiKey': key
        })

        const engineType = H.Map.EngineType['HARP'];

        // Obtain the default map types from the platform object:
        const defaultLayers = platform.createDefaultLayers({engineType: engineType, lg: languageCode});

        // Instantiate (and display) a map object:
        map = new H.Map(component, defaultLayers.vector.normal.map, {
            zoom: initZoom,
            center: {lat: initLatitude, lng: initLongitude},
            pixelRatio: window.devicePixelRatio || 1,
            padding: {top: 100, left: 50, bottom: 50, right: 50},
            engineType: engineType
        });
        // add a resize listener to make sure that the map occupies the whole container
        window.addEventListener('resize', () => map.getViewPort().resize());

        // Enable the event system on the map instance:
        const mapEvents = new H.mapevents.MapEvents(map);

        // Instantiate the default behavior, providing the mapEvents object:
        const behavior = new H.mapevents.Behavior(mapEvents);
        
        // disable wheel zoom behavior and implement own one to scroll the page instead
        behavior.disable(H.mapevents.Behavior.WHEELZOOM)
        map.addEventListener('wheel', function(evt) {
            window.scrollBy({left: 0, top: evt.originalEvent.deltaY, behavior: "instant"});
        });

        // disable dragging on touch and with one pointer (
        let startY;
        map.addEventListener('dragstart', function(evt) {
            if (evt.currentPointer.type === 'touch' && evt.pointers.length < 2) {
                startY = evt.currentPointer.viewportY;
                behavior.disable(H.mapevents.Behavior.DRAGGING);
            }
        });

        map.addEventListener('drag', function(evt) {
            if (evt.currentPointer.type === 'touch' && evt.pointers.length < 2) {
                window.scrollBy({left: 0, top: (startY - evt.currentPointer.viewportY), behavior: "instant"});
            }
        });

        map.addEventListener('dragend', function(evt) {
            behavior.enable(H.mapevents.Behavior.DRAGGING);
        });


        let code = new H.ui.i18n.Localization("en-US");
        if(languageCode && countryCode){
            try {
                code = new H.ui.i18n.Localization(languageCode + "-" + countryCode);
            } catch (e) {
                //do nothing and use default
                console.debug("Default local is used (en-US) - local not supported: {}", e)
            }
        }
        // Create the default UI:
        const ui = H.ui.UI.createDefault(map, defaultLayers, code);

        markerClustering = new MarkerClustering(map, ui, clickOnPointOfInterest, markerClusteringImage, pinIconSvg)

        // geolocation access request if initial coordinates are not set
        if (!dataInitLongitude || !dataInitLatitude) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    map.setCenter({lat: position.coords.latitude, lng: position.coords.longitude});
                    map.setZoom(11);
                }, function () {
                    map.setCenter({lat: 0, lng: 0});
                    map.setZoom(2);
                });
            }
        }

        // check if Datasource for Markers is assigned or not
        if (dataPool) {
            var xhr = new XMLHttpRequest();
            // send http Request to Servlet to get Markers
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200 && xhr.response) {
                    // get POI JSON Objects from Response and iterate over them
                    var pointsOfInterest = JSON.parse(xhr.response);
                    setPointsOfInterests(pointsOfInterest);
                }
            };
            xhr.open("GET", dataPool, true);
            xhr.send();
        }
    }

    /**
     * SET POINTS-OF-INTEREST
     * Set Point of Interests on the Map.
     */
    var setPointsOfInterests = function (pointsOfInterests) {

        markerClustering.setMarkers(pointsOfInterests)
    }

    /**
     * CREATE INFO CONTENT
     * create info content for pointOfInterest
     *
     * @param pointOfInterest
     * @returns {HTMLDivElement}
     */
    var createInfoContent = function (pointOfInterest) {

        var container = document.createElement('div');
        container.classList.add('iw-container');

        var title = document.createElement('h3');
        title.innerHTML = pointOfInterest.title;
        container.appendChild(title);

        var content = document.createElement('div');
        content.classList.add('iw-content');

        createInfoContentImage(content, pointOfInterest);
        createInfoContentDescription(content, pointOfInterest);
        createInfoContentLink(content, pointOfInterest);
        createInfoContentButtonApplySelection(content, pointOfInterest);

        container.appendChild(content);
        return container;

    }

    /**
     * CREATE INFO CONTENT IMAGE
     * Creates Info Content for image if pointOfInterest.image exist
     *
     * @param content
     * @param pointOfInterest
     */
    var createInfoContentImage = function (content, pointOfInterest) {

        if (pointOfInterest && pointOfInterest.image && pointOfInterest.image.length > 0) {

            var img = document.createElement('img');
            img.setAttribute('src', pointOfInterest.image);
            img.setAttribute('height', "58");
            img.setAttribute('width', "116");
            content.appendChild(img);

        }

    }

    /**
     * CREATE INFO CONTENT DESCRIPTION
     * Creates info content for description if pointOfInterest.description exist
     *
     * @param content
     * @param pointOfInterest
     */
    var createInfoContentDescription = function (content, pointOfInterest) {

        if (pointOfInterest && pointOfInterest.description && pointOfInterest.description.length > 0) {

            var template = document.createElement('template')
            template.innerHTML = pointOfInterest.description.trim();
            content.appendChild(template.content.firstChild);

        }
    }

    /**
     * CREATE INFO CONTENT LINK
     * crate info content for link if pointOfInterest.link exist
     *
     * @param content
     * @param pointOfInterest
     */
    var createInfoContentLink = function (content, pointOfInterest) {

        if (pointOfInterest && pointOfInterest.link && pointOfInterest.link.target && pointOfInterest.link.url && pointOfInterest.link.text) {

            var link = document.createElement("a");
            link.classList.add("c-btn");
            link.classList.add("c-btn--link");
            link.classList.add("c-btn--small");
            link.setAttribute("data-tr-component", "Link")

            var disclaimerLink = pointOfInterest.link.disclaimer;
            if (disclaimerLink && disclaimerLink.length > 0) {
                link.setAttribute("data-disclaimer-ref", disclaimerLink);
            }
            var title = pointOfInterest.link.title;
            if (title && title.length > 0) {
                link.setAttribute("title", title);
            }

            link.setAttribute("target", pointOfInterest.link.target);
            link.setAttribute("href", pointOfInterest.link.url);

            var icon = document.createElement("i");
            icon.classList.add("c-btn__icon");
            icon.classList.add("c-icon");
            icon.classList.add("c-icon--[semantic-forward]");
            link.appendChild(icon);

            var span = document.createElement("span");
            span.classList.add("c-btn__text");
            span.innerText = pointOfInterest.link.text
            link.appendChild(span);

            content.appendChild(link);

        }

    }

    /**
     * CREATE INFO CONTENT BUTTON APPLY SECTION
     * return link if showButtonApplySelection === true
     *
     * @param content
     * @param pointOfInterest
     */
    var createInfoContentButtonApplySelection = function (content, pointOfInterest) {

        if (showButtonApplySelection) {

            var div = document.createElement("div");
            div.classList.add("o-button-container");
            div.classList.add("u-mt-small");
            div.classList.add("o-button-container--center");

            var button = document.createElement("a");
            button.classList.add("c-btn");
            button.classList.add("c-btn--secondary");
            button.setAttribute("json-data", JSON.stringify(pointOfInterest));

            var span = document.createElement("span");
            span.classList.add("c-btn__text");
            span.innerText = textApplySelection;
            button.appendChild(span);
            div.appendChild(button);

            button.addEventListener('click', clickApplySelection);
            content.appendChild(div);

        }

    }

    /**
     * EVENT > ON CLICK POINT-OF-INTEREST
     */
    var clickOnPointOfInterest = function (position, pointOfInterest, ui, marker) {

        return function () {
            let content = createInfoContent(pointOfInterest);
            // For all markers create only one bubble, if not created yet
            if (!infoWindow) {
                infoWindow = new H.ui.InfoBubble(position, {
                    content: content
                });
                ui.addBubble(infoWindow);
            } else {
                // Reuse existing bubble object
                infoWindow.setPosition(position);
                infoWindow.setContent(content);
                infoWindow.open();
            }
            // Move map's center to a clicked marker
            map.setCenter(position, true);

            VWFSUtils.dispatchEvent(document, "reInitLinks");
        }

    }

    /**
     * EVENT > UPDATE POINTS-OF-INTEREST
     */
    var updatePointsOfInterests = function (event) {

        // CLEAR MAP FROM MARKERS
        markerClustering.setMarkers([])

        if (event && event.detail && event.detail.pointsOfInterests) {

            // SET NEW POINTS-OF-INTEREST
            setPointsOfInterests(event.detail.pointsOfInterests);

            // FIRE EVENT
            if (listener) {
                VWFSUtils.dispatchEvent(listener, 'updatedPointsOfInterests');
            }
        }
    }

    /**
     * EVENT > ON APPLY SELECTION
     */
    var clickApplySelection = function (event) {

        var jsonData = JSON.parse(event.currentTarget.getAttribute("json-data"));
        if (listener) {
            VWFSUtils.dispatchEvent(listener, 'applyPointOfInterest', {detail: {pointOfInterest: jsonData}});
        }

        infoWindow.close();

    }

    /**
     * EVENT > ON REGISTER LISTENER
     */
    var onRegisterListener = function (event) {

        if (event && event.detail) {
            listener = event.detail;
        }

    }
};


/**
 * ON DOCUMENT LOADED
 */
document.addEventListener('DOMContentLoaded', function () {

    console.debug("INFO hereMap.js loaded");

    // ITERATE THROUGH ALL HEREMAPS-COMPONENTS AND INIT THEM
    document.querySelectorAll(".js-heremap").forEach(function (component) {
        new VWFS.HereMap(component).init();
    });
});
